
// OurMission.js

import React from 'react';

import ScrollableForm from '../components/foundation/ScrollableForm';
import Spacer from '../components/foundation/Spacer';
import Footer from '../components/navigation/Footer';
import TitleField from '../components/text/TitleField';
import SubTitleField from '../components/text/SubTitleField';
import TextField from '../components/text/TextField';
import CenteredImage from '../components/design/CenteredImage';
import NicheWareLogo from '../images/logo/logo512.png';
import CenteredContentPage from '../components/foundation/CenteredContentPage';


import Hero from '../components/home/Hero';
import ProductOverview from '../components/home/ProductsOverview';
import Process from '../components/home/Process';

const OurMission = () => {


    return (
 <>
            <ScrollableForm>

                <CenteredContentPage>
                </CenteredContentPage>  
                
                <Footer/>
            </ScrollableForm>
        </>
    )
}


export default OurMission;